"use client";

import { useEffect } from "react";

import { useBlogFilterNavigation } from "@/components/blog/CcBlogFilterNavigation";

type CcBlogToolbarTotalSyncProps = {
  total: number;
};

export function CcBlogToolbarTotalSync({ total }: CcBlogToolbarTotalSyncProps) {
  const { syncResultsTotal } = useBlogFilterNavigation();

  useEffect(() => {
    syncResultsTotal(total);
  }, [total, syncResultsTotal]);

  return null;
}
